import { useBranding } from '@/lib/branding/BrandingProvider';

export function BootSplash() {
  const { logoUrl, name, productName } = useBranding();

  return (
    <div className="relative grid min-h-screen place-items-center overflow-hidden bg-neurax-ink">
      <div className="absolute inset-0 bg-neurax-glow opacity-80" />
      <div className="absolute inset-0 grid-bg opacity-30" />
      <div className="relative flex flex-col items-center gap-5">
        <div className="relative flex h-16 items-center justify-center">
          <img
            src={logoUrl}
            alt={name}
            className="relative h-16 w-auto max-w-[280px] object-contain drop-shadow-[0_0_24px_rgba(91,124,255,0.45)]"
          />
        </div>
        <div className="text-center">
          <p className="font-display text-lg font-semibold tracking-wide text-white">
            {productName}
          </p>
          <p className="mt-1 text-xs text-muted-foreground">Spinning up your workspace…</p>
        </div>
      </div>
    </div>
  );
}
